module.exports = __webpack_public_path__ + "static/level-5-card.d883731a.png";